import { CbhIcon, mergeSxProps, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { CardContent, Stack, type SxProps, type Theme } from "@mui/material";

import { Button } from "../../../components/Button";
import { ShiftCardWrapper } from "../../../Shift/Card/Wrapper";
import { isScoreHealthy } from "../../utils/utils";
import { RankingLabelWithIcon } from "../RankingLabel";

interface EnrolledBannerProps {
  score: number;
  rank?: number;
  outOf?: number;
  qualification: string;
  onCtaClick: () => void;
  sx?: SxProps<Theme>;
}

export function EnrolledBanner(props: EnrolledBannerProps) {
  const { score, rank, outOf, qualification, onCtaClick, sx } = props;

  return (
    <ShiftCardWrapper
      sx={mergeSxProps((theme) => {
        const background = isScoreHealthy(score)
          ? theme.palette.onboarding?.inProgress?.gradient
          : theme.palette.onboarding?.error.gradient;
        return {
          padding: theme.spacing(5),
          background,
          color: theme.palette.text.primary,
        };
      }, sx)}
    >
      <CardContent>
        <Stack spacing={3} justifyContent="space-between" alignItems="center">
          <Text variant="h1">{score}</Text>

          {isDefined(rank) && isDefined(outOf) && (
            <RankingLabelWithIcon
              score={score}
              rank={rank}
              outOf={outOf}
              qualification={qualification}
            />
          )}

          <Button invert onClick={onCtaClick}>
            Your Clipboard Score
            <CbhIcon size="small" type="chevron-right" />
          </Button>
        </Stack>
      </CardContent>
    </ShiftCardWrapper>
  );
}
